import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAppContext } from 'components/Context/AppContext';
import { getAllDriversByFilter } from 'features/drivers/actions';
import { getDetailOrder } from 'features/orders/detailOrderSlice';
import Modals from '../Modals';
import { Button, InputField } from 'components/Global';
import { ReactComponent as VehicleIcon } from 'icons/car-blue-bg.svg';
import { ReactComponent as SearchIcon } from 'icons/search-icon-black.svg';
import { checkEmptyObject, gotFeeCurrency } from 'utils/functionality';
import SelectDriverOptions from 'components/Global/SelectDriverOptions';
import { format, parseISO } from 'date-fns';
import { id } from 'date-fns/locale';
import { getConvertCurrency } from 'features/convert-currency/actions';

import SelectFieldDropdown from 'components/Global/SelectFieldDropdown';

const SEND_TASK_TYPE = [
  {
    id: 'stt1',
    value: 'all',
    name: 'Kirim ke Semua Driver',
  },
  {
    id: 'stt2',
    value: 'individual',
    name: 'Kirim ke Individual Driver',
  },
];

const BroadcastTaskCharterModal = () => {
  const dispatch = useDispatch();

  const { setShowBroadcastTask, setShowBroadcastTaskCharter, showToast, setShowConfirmBroadcastTaskCharter } =
    useAppContext();

  const { data: driversData } = useSelector((state) => state.drivers);
  const orderData = useSelector(getDetailOrder);
  const { data: calculateFeeTaskResult } = useSelector((state) => state.calculateFeeTask);
  const { data: convertCurrencyData } = useSelector((state) => state.convertCurrency);

  const [isToAllDriver, setIsToAllDriver] = useState(true);
  const [taskType, setTaskType] = useState(null);

  const [selectedDriver, setSelectedDriver] = useState(undefined);

  const [inputValueDrivers, setInputValueDrivers] = useState('');

  const submitHandler = async () => {
    if (taskType === null) {
      return showToast({ type: 'error', message: 'Pilih Kirim Task!' });
    }

    setShowBroadcastTaskCharter(false);
    setShowConfirmBroadcastTaskCharter({
      show: true,
      fee: typeof convertCurrencyData?.converted_amount === 'number' ? convertCurrencyData?.converted_amount : 0,
      task_type: SEND_TASK_TYPE.find((item) => item.id === taskType)?.name ?? '',
      driver: isToAllDriver ? '' : selectedDriver,
      currency: 'IDR',
    });
  };

  useEffect(() => {
    if (
      !calculateFeeTaskResult ||
      checkEmptyObject(calculateFeeTaskResult) ||
      !orderData ||
      checkEmptyObject(orderData)
    )
      return;

    dispatch(
      getConvertCurrency({
        fromCurrency: calculateFeeTaskResult.to_currency,
        toCurrency: calculateFeeTaskResult.from_currency,
        amount: calculateFeeTaskResult.fee_driver,
        date: format(parseISO(orderData?.created_at), 'yyyy-MM-dd', { locale: id }),
      }),
    );
  }, [calculateFeeTaskResult, orderData]);

  useEffect(() => {
    if (inputValueDrivers) {
      const timeout = setTimeout(() => {
        dispatch(
          getAllDriversByFilter({
            page: 0,
            limit: 0,
            search: inputValueDrivers,
            locationId: orderData?.order_detail?.location_id,
            isDeactivated: false,
          }),
        );
      }, 500);

      return () => clearTimeout(timeout);
    }

    dispatch(
      getAllDriversByFilter({
        page: 0,
        limit: 0,
        locationId: orderData?.order_detail?.location_id,
        isDeactivated: false,
      }),
    );
  }, [inputValueDrivers]);

  const chooseSendTaskTypeHandler = (e) => {
    const id = e.target.id;

    const choosenType = SEND_TASK_TYPE.find((item) => item.id === id);
    if (choosenType) {
      setTaskType(choosenType.id);

      if (choosenType.value === 'all') {
        setIsToAllDriver(true);
      } else {
        setIsToAllDriver(false);
      }
    }
  };

  const feeDriver = convertCurrencyData?.converted_amount;

  return (
    <Modals
      setState={setShowBroadcastTask}
      icon={<VehicleIcon fill="#009EF7" width="25px" height="25px" />}
      title={'Broadcast Task Driver'}
    >
      <div className="broadcast-task-modal">
        <h2>{isToAllDriver ? 'Broadcast Task ke seluruh Driver Get&Ride' : 'Broadcast Task'}</h2>
        <form>
          <InputField
            label="Fee Per Task"
            htmlFor="fee-per-task"
            placeholder="0"
            value={typeof feeDriver === 'number' ? gotFeeCurrency(feeDriver, 'IDR').replace('Rp', 'IDR') : ''}
            disable
          />

          <SelectFieldDropdown
            label="Kirim Task"
            htmlFor="kirim-task"
            className="task-type"
            placeholder="Pilih Kirim Task"
            data={SEND_TASK_TYPE}
            value={taskType}
            onChange={chooseSendTaskTypeHandler}
          />

          {!isToAllDriver && (
            <div className="drivers-wrapper">
              <SelectDriverOptions
                label="Kirim ke Driver"
                className="driver-list"
                htmlFor="driver-list"
                icon={<SearchIcon />}
                iconPosition="end"
                data={driversData?.users}
                selectedDriver={selectedDriver}
                onSelectDriver={(driver) => {
                  setSelectedDriver(driver);
                  setInputValueDrivers('');
                }}
                value={inputValueDrivers}
                onChange={(e) => setInputValueDrivers(e.target.value)}
                disabled={isToAllDriver}
                placeholder="Pilih Driver"
              />
            </div>
          )}

          <div className="action-buttons">
            <Button variant="outline" type="button" onClick={() => setShowBroadcastTaskCharter(false)}>
              Kembali
            </Button>
            <Button type="button" onClick={submitHandler}>
              Kirim
            </Button>
          </div>
        </form>
      </div>
    </Modals>
  );
};

export default BroadcastTaskCharterModal;
